import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";

import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { useAnalytics } from "@/hooks/useAnalytics";

import UnlockMaite from "../images/UnlockMaite.png";
import { UnlockMaiteModal } from "./UnlockMaiteModal";

interface UnlockPowerPlayProps {
  onLearnMore?: () => void;
}

export const UnlockPowerPlay: React.FC<UnlockPowerPlayProps> = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { buttonClicked } = useAnalytics();

  const handleLearnMoreClick = () => {
    // Track analytics
    buttonClicked({
      buttonName: "Learn More",
      buttonLocation: "Growth Center - Unlock Power Play",
      buttonType: "modal",
    });

    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box>
      <Stack direction="row" spacing={4} alignItems="center">
        {/* Left side - Image */}
        <Box width={"40%"}>
          <img
            src={UnlockMaite}
            alt="MAITE Premium Power Plays Interface"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "400px",
              borderRadius: "8px",
            }}
          />
        </Box>

        <Box width={"60%"}>
          <Typography variant="h6" component="h2" fontWeight="600" mb={2}>
            Unlock <span style={{ color: "#FF1493" }}>Power Plays</span> with MAITE Premium
          </Typography>

          <Typography variant="body1" color="text.secondary" mb={3} lineHeight={1.6}>
            MAITE can automatically generate ‘Power Play’ experiments designed to boost your ROI and
            improve efficiency. <br /> Talk to your Marketing Science Partner today to unlock MAITE
            and MAITE Power Plays.
          </Typography>

          <OutlinedButton variant="outlined" size="large" onClick={handleLearnMoreClick}>
            Learn More
          </OutlinedButton>
        </Box>
      </Stack>

      <UnlockMaiteModal open={isModalOpen} onClose={handleCloseModal} />
    </Box>
  );
};
